import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { SiteContentProvider } from "@/context/SiteContentContext";
import { LanguageProvider } from "@/context/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SiteContentProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </SiteContentProvider>
    </BrowserRouter>
  </React.StrictMode>
);
